
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/sitemap",
      function () {
        return require("private-next-pages/en/sitemap/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/sitemap"])
      });
    }
  